import axios from "../../utils/axios";

// 国家分区管理
export function getList(query) {
    return axios({
        url: "cunsubareaManage/getList",
        method: "get",
        params: query
    });
}

//国家分区删除
export function deleteCunSubarea(data) {
    return axios({
        url: "cunsubareaManage/delete",
        method: "post",
        data: data
    });
}

export function edit(data) {
    return axios({
        url: "cunsubareaManage/edit",
        method: "post",
        data: data
    });
}
// 国家分区增加
export function addCunSubarea(data) {
    return axios({
        url: "cunsubareaManage/update",
        method: "post",
        data: data
    });
}

// 国家分区修改
export function updateCunSubarea(data) {
    return axios({
        url: "cunsubareaManage/update",
        method: "post",
        data: data
    });
}

// 查询详情
export function getCunSubareaInfo(data) {
    return axios({
        url: "cunsubareaManage/getInfo",
        method: "get",
        params: data
    });
}

// 查询DHL仓库
export function getDHLSubArea(data) {
    return axios({
        url: "cunsubareaManage/getDHLSubarea",
        method: "get",
        params: data
    });
}

// 查询联邦仓库
export function getLBSubArea(data) {
    return axios({
        url: "cunsubareaManage/getLBSubArea",
        method: "get",
        params: data
    });
}

// 查询HFM仓库
export function getHFMSubArea(data) {
    return axios({
        url: "cunsubareaManage/getHFMSubArea",
        method: "get",
        params: data
    });
}

// 查询国家
export function getCountry(data) {
    return axios({
        url: "cunsubareaManage/getCountry",
        method: "get",
        params: data
    });
}

